export default function reverseString(value: string) {
  return value.split('').reverse().join('')
}
